import commafy from "./commafy";
import padLeft from "./padLeft";

interface IOptions {
    hideZeroCents?: boolean;
    negativeFormat?: "dash" | "parenthesis";
    symbolPrefix?: undefined | string;
    symbolSuffix?: undefined | string;
    zeroText?: undefined | string;
}

const defaultFormatDollarOptions: IOptions = {
    hideZeroCents: false,
    negativeFormat: "dash",
    zeroText: undefined,
};

export default function formatDollar(amount: number, extraOptions?: IOptions): string {
    const options: IOptions = {
        ...defaultFormatDollarOptions,
        ...extraOptions,
    };
    const CENT_MULTIPLIER = 10;
    const CENT_POSITIONS = 2;
    const DOLLAR_IN_CENTS = Math.pow(CENT_MULTIPLIER, CENT_POSITIONS);

    const amountIsNegative = amount < 0;
    const absoluteAmount = Math.abs(amount);
    const cents = Math.floor(absoluteAmount * DOLLAR_IN_CENTS) % DOLLAR_IN_CENTS;
    const amountHasZeroCents = cents === 0;
    const dollars = Math.floor(absoluteAmount);

    // If zeroText is provided, use it if there is no dollar amount
    if (options.zeroText && amount === 0) {
        return options.zeroText;
    }

    let output = "";

    // Prepend symbol
    if (options.symbolPrefix) {
        output += options.symbolPrefix;
    }

    // Add commafied values
    output += commafy(dollars);

    // Optionally provide cents formatting
    if (!(options.hideZeroCents && amountHasZeroCents)) {
        output += `.${ padLeft(cents, CENT_POSITIONS, "0") }`;
    }

    // Append symbol
    if (options.symbolSuffix) {
        output += options.symbolSuffix;
    }

    // Negative formatting
    if (amountIsNegative) {
        switch (options.negativeFormat) {
            case "parenthesis":
                output = `(${ output })`;
                break;

            default:
                output = `-${ output }`;
        }
    }

    return output;
}



// WEBPACK FOOTER //
// ./src/utils/formatDollar.ts